/* global Modernizr */
import noUiSlider from 'nouislider';
import { triggerEvent } from '../lib/helper';


export default class RangeSlider {

  constructor(el) {

    this.el = el;
    this.sliderWrapper = this.el.querySelector('.tc-range-slider');
    this.min = parseFloat(this.el.getAttribute('data-min-range'));
    this.max = parseFloat(this.el.getAttribute('data-max-range'));
    this.minStart = parseFloat(this.el.getAttribute('data-min-start'));
    this.maxStart = parseFloat(this.el.getAttribute('data-max-start'));
    this.steps = parseFloat(this.el.getAttribute('data-slider-precision'));
    this.isDisabled = this.el.hasAttribute('data-disabled');
    this.minInput = this.el.querySelector('.range-min-input-visible');
    this.maxInput = this.el.querySelector('.range-max-input-visible');
    this.minInputHidden = this.el.querySelector('.range-min-input');
    this.maxInputHidden = this.el.querySelector('.range-max-input');
    this.minSelects = this.el.querySelector('.range-min-select');
    this.maxSelects = this.el.querySelector('.range-max-select');
    this.useSelects = false;

    try {

      this.formattingOptions = JSON.parse(this.el.getAttribute('data-formatter'));
    } catch (error) {

      this.formattingOptions = null;
    }

    // use selects for touchdevices
    if (Modernizr && Modernizr.touchevents) {

      this.useSelects = true;
      this.initSelects();
    } else {

      this.initSlider();
    }
  }

  initSlider() {

    if (isNaN(this.min) || isNaN(this.max)) {

      try {

        this.rangeObject = JSON.parse(this.el.getAttribute('data-range-settings'));
      } catch (error) {

        return;
      }

      let i = 0;
      this.count = 0;
      this.noUiRange = {};
      this.noUiRangeTranslation = [];

      for (let o in this.rangeObject) {

        if (this.rangeObject.hasOwnProperty(o)) {

          this.count++;
        }
      }

      for (let o in this.rangeObject) {

        if (this.rangeObject.hasOwnProperty(o)) {

          if (i === 0) {

            this.noUiRange.min = i; //this.rangeObject[o].displayName;
          } else if (i === this.count - 1) {

            this.noUiRange.max = i;
          }

          this.noUiRangeTranslation.push(this.rangeObject[o]);
          i++;
        }
      }
    }

    let min = 0;
    let max = this.count - 1;

    if (this.minStart) {

      min = this.minStart;
    } else if (this.min) {

      min = this.min;
    }

    if (this.maxStart) {

      max = this.maxStart;
    } else if (this.max) {

      max = this.max;
    }

    this.start = [min, max];
    this.range = (this.noUiRange) ? this.noUiRange : {
      'min': this.min,
      'max': this.max
    };

    this.rangeSlider = noUiSlider.create(this.sliderWrapper, {
      start: this.start,
      step: (this.steps) ? this.steps : 1,
      // format:,
      connect: true, // Display a colored bar between the handles
      behaviour: 'tap-drag', // Move handle on tap, bar is draggable
      range: this.range
    });

    if (this.isDisabled) {

      this.sliderWrapper.setAttribute('disabled', true);
    }

    this.bindSlider();
  }

  initSelects() {

    this.minSelects.addEventListener('change', () => {

      const val = this.minSelects.options[this.minSelects.options.selectedIndex].value;
      let parsedVal = val;

      // if ( this.minSelects.selectedIndex === 0 ) {
      //
      //   this.minInput.value = '';
      //   this.minInputHidden.value = '';
      // } else {

      if (this.formattingOptions && this.formattingOptions.parse) {

        parsedVal = this.parse(val, this.formattingOptions.parse.from, this.formattingOptions.parse.decimalPlace);
      }

      this.minInput.value = this.setFormat(parsedVal, 'displayName');

      if (this.noUiRangeTranslation) {

        this.minInputHidden.value = this.setFormat(parsedVal, 'value');
      } else {

        this.minInputHidden.value = val;
      }
      // }
      triggerEvent(this.minInput, 'change');
      triggerEvent(this.minInputHidden, 'change');
    });

    this.maxSelects.addEventListener('change', () => {

      const val = this.maxSelects.options[this.maxSelects.options.selectedIndex].value;
      let parsedVal = val;

      // if ( this.maxSelects.selectedIndex === 0 ) {
      //
      //   this.maxInput.value = '';
      //   this.maxInputHidden.value = '';
      // } else {

      if (this.formattingOptions && this.formattingOptions.parse) {

        parsedVal = this.parse(val, this.formattingOptions.parse.from, this.formattingOptions.parse.decimalPlace);
      }

      this.maxInput.value = this.setFormat(parsedVal, 'displayName');

      if (this.noUiRangeTranslation) {

        this.maxInputHidden.value = this.setFormat(parsedVal, 'value');
      } else {

        this.maxInputHidden.value = val;
      }
      // }
      triggerEvent(this.maxInput, 'change');
      triggerEvent(this.maxInputHidden, 'change');
    });
  }

  /**
   * bind inputs to the slider
   * @return {[type]} [description]
   */
  bindSlider() {

    this.sliderWrapper.noUiSlider.on('update', (values, handle) => {

      const value = values[handle];

      if (handle === 0) {
        this.minInput.value = this.setFormat(value, 'displayName');

        if (this.noUiRangeTranslation) {

          this.minInputHidden.value = this.setFormat(value, 'value');
        } else {

          this.minInputHidden.value = value;
        }
      }

      if (handle === 1) {
        this.maxInput.value = this.setFormat(value, 'displayName');

        if (this.noUiRangeTranslation) {

          this.maxInputHidden.value = this.setFormat(value, 'value');
        } else {

          this.maxInputHidden.value = value;
        }
      }
    });

    this.sliderWrapper.noUiSlider.on('change', (values, handle) => {

      if (handle === 0) {
        triggerEvent(this.minInput, 'change');
        triggerEvent(this.minInputHidden, 'change');
      }

      if (handle === 1) {
        triggerEvent(this.maxInput, 'change');
        triggerEvent(this.maxInputHidden, 'change');
      }
    });

    this.minInput.addEventListener('change', () => {

      this.rangeSlider.set([this.resetFormat(this.minInput.value), null]);
    });

    this.maxInput.addEventListener('change', () => {

      this.rangeSlider.set([null, this.resetFormat(this.maxInput.value)]);
    });
  }

  setFormat(inputVal, translationType) {

    if (!this.formattingOptions || this.noUiRangeTranslation) {

      if (this.noUiRangeTranslation) {

        inputVal = this.noUiRangeTranslation[parseInt(inputVal, 10)][translationType];
      }

      return inputVal;
    }

    if (this.formattingOptions.parse) {

      inputVal = this.parse(inputVal, this.formattingOptions.parse.to, this.formattingOptions.parse.decimalPlace, this.formattingOptions.parse.from);
    }

    if (this.formattingOptions.replacements && this.formattingOptions.replacements.length) {

      for (let i = 0; i < this.formattingOptions.replacements.length; i++) {

        inputVal = inputVal.replace(this.formattingOptions.replacements[i].from, this.formattingOptions.replacements[i].to);
      }
    }

    if (this.formattingOptions.prefix) {

      inputVal = this.formattingOptions.prefix + inputVal;
    }

    if (this.formattingOptions.suffix) {

      inputVal += this.formattingOptions.suffix;
    }

    return inputVal;
  }

  resetFormat(inputVal) {

    if (!this.formattingOptions || this.noUiRangeTranslation) {

      if (this.noUiRangeTranslation) {

        for (let i = 0; i < this.noUiRangeTranslation.length; i++) {

          if (this.noUiRangeTranslation[i].displayName == inputVal) {

            inputVal = i;
            break;
          }
        }

        // inputVal = (this.noUiRangeTranslation.indexOf(inputVal) >= 0) ? this.noUiRangeTranslation.indexOf(inputVal) : inputVal;
      }

      return inputVal;
    }

    if (this.formattingOptions.suffix) {

      inputVal = inputVal.replace(this.formattingOptions.suffix, '');
    }

    if (this.formattingOptions.prefix) {

      inputVal = inputVal.replace(this.formattingOptions.prefix, '');
    }

    if (this.formattingOptions.replacements && this.formattingOptions.replacements.length) {

      for (let i = this.formattingOptions.replacements.length - 1; i >= 0; i--) {

        inputVal = inputVal.replace(this.formattingOptions.replacements[i].to, this.formattingOptions.replacements[i].from);
      }
    }

    if (this.formattingOptions.parse) {

      inputVal = this.parse(inputVal, this.formattingOptions.parse.from, this.formattingOptions.parse.decimalPlace, this.formattingOptions.parse.to);
    }

    return inputVal;
  }

  parse(val, type, decimalPlace, fromType) {

    switch (type) {
    case 'float':
      val = parseFloat(val);
      val = val.toFixed(decimalPlace || 2);
      break;
    case 'int':

      val = parseInt(val, 10);
      break;
    case 'string':

      if (fromType && fromType == 'int') {

        val = parseInt(val, 10);
      }

      val = val.toString();
      break;
    case 'hours':

      if (fromType && fromType === 'min') {

        const h = (Math.floor(parseInt(val, 10) / 60)).toString();
        let min = (parseInt(val, 10) % 60).toString();

        if (min.length < 2) {

          for (let i = 2 - min.length; i > 0; i--) {

            min = '0' + min;
          }
        }

        val = h + ':' + min;
      }
      break;
    case 'min':

      if (fromType && fromType === 'hours') {

        const t = val.split(':');
        const h = parseInt(t[0], 10) * 60;
        let min = parseInt(t[1], 10);

        if (min) {

          val = (h + min);
        } else {

          val = h;
        }
      }
      break;
    }

    return val;
  }

  resetValues(min, max) {

    if (this.useSelects) {

      if (max) {

        this.maxSelects.selectedIndex = 0;
        triggerEvent(this.maxSelects, 'change');
      }

      if (min) {

        this.minSelects.selectedIndex = 0;
        triggerEvent(this.minSelects, 'change');
      }
    } else {

      if (max) {

        this.sliderWrapper.noUiSlider.set([null, this.sliderWrapper.noUiSlider.options.range.max]);
        triggerEvent(this.maxInput, 'change');
        triggerEvent(this.maxInputHidden, 'change');
      }

      if (min) {

        this.sliderWrapper.noUiSlider.set([this.sliderWrapper.noUiSlider.options.range.min, null]);
        triggerEvent(this.minInput, 'change');
        triggerEvent(this.minInputHidden, 'change');
      }
    }
  }
};
